import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ImageSourceSetData } from "./classes/ImageSourceSet";

import styles from "./ExpansionImage.module.scss";

type Props = {
  img: File | ImageSourceSetData;
  alt?: string;
  onClose: () => void;
};

const ExpansionImage: React.FC<Props> = ({ img, alt, onClose }) => {
  return (
    <div className={styles["c-expansionImg"]}>
      <div className={styles["c-expansionImg__content"]}>
        <img
          src={img instanceof File ? URL.createObjectURL(img) : img.medium.url}
          alt={alt}
        />
        <button onClick={onClose}>
          <FontAwesomeIcon icon={["fas", "times"]} />
        </button>
      </div>
    </div>
  );
};

export default ExpansionImage;
